/// <summary>
/// 配置相关
/// </summary>

import KitAPI from "./KitAPI";
import KitLog from "./KitLog";
import {JsonData} from "@/Fwk/Kit/JsonData";

/// <author>xiexingwu</author>
export default class KitCfg {
    private static _resJson: JsonData;

    public static get resJson(): JsonData {
        if (this._resJson != null) return this._resJson;
        const [isTest, config] = KitAPI.GetConfigAsset();
        this._resJson = this.Build(config);
        if (KitLog.IsLog) KitLog.Log(`产品配置【${isTest ? "测试" : "正式"}】:${this._resJson}`);
        return this._resJson;
    }

    protected static Build = (js: string): JsonData => {
        // 解析JSON文件
        if (js) return new JsonData(null, js);
        if (KitLog.IsLog) KitLog.Log("Failed to deserialize Config JSON file.");
        return new JsonData();
    };

    static get adjust_app_token1(): string {
        return this.resJson.OptString("adjust_app_token");
    }

    static get adjust_app_token2(): string {
        return this.resJson.OptString("from_sdk", "adjust_app_token"); //兼容旧配置文件格式
    }

    static get adjust_event_token1(): string {
        return this.resJson.OptString("adjust_event_token");
    }

    static get adjust_event_token2(): string {
        return this.resJson.OptString("from_sdk", "adjust_event_token"); //兼容旧配置文件格式
    }

    static get adjust_app_token(): string {
        return this.adjust_app_token1 ? this.adjust_app_token1 : this.adjust_app_token2;
    }

    static get adjust_event_token(): string {
        return this.adjust_event_token1 ? this.adjust_event_token1 : this.adjust_event_token2;
    }

    static get bugly_id(): string {
        return this.resJson.OptString("bugly_id");
    }

    static get jsonString(): string {
        return this.resJson.toString();
    }

    static get productId(): number {
        return this.resJson.OptInt("productId");
    }

    static get releaseProductId(): number {
        return this.resJson.OptInt("releaseProductId");
    }

    static get ia_host(): string {
        return this.resJson.OptString("ia_host");
    }

    static get max_key(): string {
        return this.resJson.OptString("max_key");
    }

    static get privacy_url(): string {
        return this.resJson.OptString("privacy_url");
    }

    static get trems_url(): string {
        return this.resJson.OptString("trems_url");
    }

    static get mail(): string {
        return this.resJson.OptString("mail");
    }

    static get nat_host(): string {
        return this.resJson.OptString("nat_host");
    }

    static get nat_3_reward(): string {
        return this.resJson.OptString("nat_3_reward");
    }

    static get nat_2_full(): string {
        return this.resJson.OptString("nat_2_full");
    }

    static get appID(): string {
        return this.resJson.OptString("appID");
    }

    public static OptInt(key: string): number {
        return this.resJson.OptInt(key);
    }

    public static OptString(key: string): string {
        return this.resJson.OptString(key);
    }
}